import { Application, Container } from 'pixi.js';

const isTypeScript =
  typeof import.meta !== 'undefined' &&
  import.meta.env &&
  import.meta.env.MODE === 'development';

interface Flake {
  direction: number;
  turningSpeed: number;
  speed: number;
  offset: number;
  x: number;
  y: number;
  scale: any;
  anchor: any;
  rotation: number;
}

export const renderHeartEffect = async (
  app: Application | null,
  width: number,
  height: number,
  effectId: string,
  effectsSpriteRef: any
) => {
  const heartImagePath = isTypeScript
    ? '/src/assets/effects/heart.png'
    : '/assets/heart.png';
  const PIXI = await import('pixi.js');
  const texture = await PIXI.Assets.load(heartImagePath);

  // Create a container for all the maggots particles and add it to the stage
  const sprites = new PIXI.Container() as Container & {
    id?: string;
    cleanup?: () => void;
  };
  effectsSpriteRef.current = sprites;
  effectsSpriteRef.current.id = effectId;

  // Create an array to store all the sprites
  const flakes: Flake[] = [];
  const totalSprites = 8;

  for (let i = 0; i < totalSprites; i++) {
    // Create a new snowflake Sprite
    const flake: any = new PIXI.Sprite(texture);

    // Set anchor, scale, position, and custom properties
    flake.anchor.set(0.5);
    flake.scale.set(0.05);
    flake.x = Math.random() * width;
    flake.y = Math.random() * height;
    flake.direction = (3 * Math.PI) / 2; // Initial direction in radians
    flake.turningSpeed = 0; // Initial turning speed
    flake.speed = 1; // Random movement speed
    flake.offset = Math.random() * 100; // Random offset for unique movement
    // Add the heart to the array and container
    flakes.push(flake);
    sprites.addChild(flake);
  }

  // Create a bounding box box for the little hearts
  const dudeBoundsPadding = -30;
  const dudeBounds = new PIXI.Rectangle(
    -dudeBoundsPadding,
    -dudeBoundsPadding,
    width + dudeBoundsPadding * 2,
    height + dudeBoundsPadding * 2
  );

  const animate = () => {
    const heartbeatFrequency = 0.005; // Frequency of the heartbeat (adjust for speed)
    const maxScaleMultiplier = 0.5; // Maximum scale multiplier for the heartbeat effect

    // Iterate through the sprites and update their position
    for (let i = 0; i < flakes.length; i++) {
      const flake = flakes[i];

      // Update direction and position
      //flake.direction += flake.turningSpeed * 0.01;
      flake.x += Math.sin(flake.direction) * flake.speed;
      flake.y += Math.cos(flake.direction) * flake.speed;
      //flake.rotation = -flake.direction - Math.PI / 2;

      // Heartbeat effect
      const offsetFactor = (flake.x / dudeBounds.width) * Math.PI; // Offset based on x position
      const scaleFactor =
        Math.sin(
          (app?.ticker.lastTime ? app.ticker.lastTime : 0) *
            heartbeatFrequency +
            offsetFactor
        ) *
        (maxScaleMultiplier - 1) *
        0.3;
      flake.scale.set(scaleFactor);

      // Constrain the flakes' position by testing their bounds...
      if (flake.x < dudeBounds.x) {
        flake.x += dudeBounds.width;
      } else if (flake.x > dudeBounds.x + dudeBounds.width) {
        flake.x -= dudeBounds.width;
      }

      if (flake.y < dudeBounds.y) {
        flake.y += dudeBounds.height;
      } else if (flake.y > dudeBounds.y + dudeBounds.height) {
        flake.y -= dudeBounds.height;
      }
    }
  };

  if (app) {
    app.ticker.add(animate);
    sprites.cleanup = () => {
      app.ticker.remove(animate);
    };
  }

  return sprites;
};
